"use strict";

/**
 * Implements the language switcher.
 */
export default class LanguageSwitcher {
	constructor( switcher ) {
		switcher.addEventListener(
			'input',
			() => { document.location.href = switcher.value; }
		);
	}
};
